<a
    class="w-full flex flex-col items-center justify-center rounded-lg cursor bp908:hover:bg-blurple active:bg-[#F9F5F0] bp908:active:bg-blurple"
    routerLink="/admin"
    routerLinkActive="bg-primary-50 bp908:!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    #link="routerLinkActive"
    pTooltip="Admin Console"
    tooltipPosition="right">
    @if (!isHovered && !link.isActive) {
        <fa-icon class="text-18 bp908:text-white text-color" [icon]="groupIcon" />
    } @else {
        <fa-icon class="text-18 bp908:text-white text-blurple" [icon]="groupIconSolid" />
    }
</a>
